import { render, staticRenderFns } from "./licence.vue?vue&type=template&id=2f742352&scoped=true&"
import script from "./licence.vue?vue&type=script&lang=js&"
export * from "./licence.vue?vue&type=script&lang=js&"
import style0 from "./licence.vue?vue&type=style&index=0&id=2f742352&prod&lang=scss&scoped=true&"
import style1 from "./licence.vue?vue&type=style&index=1&id=2f742352&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f742352",
  null
  
)

export default component.exports